import { useQuery } from '@apollo/client/react'

import { useAccount } from '~publish/contexts/AccountContext'
import { graphql } from '~publish/graphql'

export const ReferralNavigationQuery = graphql(/* GraphQL */ `
  query referralProgramNavigation($input: ReferralProgramStatusInput!) {
    referralProgramStatus(input: $input) {
      __typename
    }
  }
`)

export function useReferralProgramNavigation({
  isReady,
  isEnabled,
  affiliateProgramEnabled,
}: {
  isReady: boolean
  isEnabled: boolean
  affiliateProgramEnabled: boolean
}): 'pending' | 'error' | 'referral' | 'legacy' {
  const { account } = useAccount()
  const organizationId = account?.currentOrganization?.id
  const { data, loading, error } = useQuery(ReferralNavigationQuery, {
    variables: { input: { organizationId: organizationId ?? '' } },
    skip: !isReady || isEnabled || !affiliateProgramEnabled || !organizationId,
  })

  if (!isReady) return 'pending'
  if (isEnabled) return 'referral'
  if (!affiliateProgramEnabled) return 'legacy'
  if (!organizationId || loading) return 'pending'
  if (error || !data?.referralProgramStatus) return 'error'
  return data.referralProgramStatus.__typename === 'ReferralProgramEnrolled'
    ? 'referral'
    : 'legacy'
}
